import { mergeClassnames } from '@porterin/component-library/src/utils/mergeClassnames';
import React from 'react';

interface LabelTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  maxWidth?: string;
}

const TruncatedText: React.FC<LabelTextProps> = ({
  text,
  maxWidth = '',
  ...props
}) => {
  return (
    <div
      {...props}
      className={mergeClassnames(`truncate ${maxWidth}`, props.className)}
    >
      {text}
    </div>
  );
};

TruncatedText.displayName = 'TruncatedText';

export default TruncatedText;
